module.exports = __webpack_public_path__ + "img/work-card4.17b51f56.png";